/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarketingConsentDto } from '../../models/marketing-consent-dto';

export interface MarketingConsentControllerFindByContactV1$Params {
  contact: string;
}

export function marketingConsentControllerFindByContactV1(http: HttpClient, rootUrl: string, params: MarketingConsentControllerFindByContactV1$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketingConsentDto>> {
  const rb = new RequestBuilder(rootUrl, marketingConsentControllerFindByContactV1.PATH, 'get');
  if (params) {
    rb.path('contact', params.contact, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MarketingConsentDto>;
    })
  );
}

marketingConsentControllerFindByContactV1.PATH = '/api/v1/marketing-consent/contact/{contact}';
